import React from "react";
import {
  Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography,
} from "@material-ui/core";
import { i18n } from "../../translate/i18n";

/**
 * Modal compartido "¿En qué quedó esta conversación?"
 * Usado tanto en flujo single (TicketActionButtons, count=1) como batch (AppBar contextual).
 *
 * Props:
 *  - open: boolean
 *  - onClose: () => void
 *  - count: number  (1 = single; >1 = batch, muestra "Vas a resolver N chats")
 *  - onResolve: (type: "ganado" | "perdido" | "sin_cambio") => void
 *  - loading?: boolean
 */
const ResolveTicketDialog = ({ open, onClose, count = 1, onResolve, loading = false }) => {
  const isBatch = count > 1;
  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>{i18n.t("resolveTicketDialog.title")}</DialogTitle>
      <DialogContent style={{ paddingBottom: 8 }}>
        {isBatch && (
          <Typography variant="body2" color="textSecondary">
            {i18n.t("resolveTicketDialog.batchCount", { count })}
          </Typography>
        )}
      </DialogContent>
      <DialogActions style={{ flexDirection: "column", gap: 8, padding: "0 16px 16px" }}>
        <Button
          fullWidth
          variant="contained"
          style={{ backgroundColor: "#4CAF50", color: "#fff" }}
          onClick={() => onResolve("ganado")}
          disabled={loading}
        >
          🏆 {i18n.t("resolveTicketDialog.won")}
        </Button>
        <Button
          fullWidth
          variant="contained"
          style={{ backgroundColor: "#F44336", color: "#fff" }}
          onClick={() => onResolve("perdido")}
          disabled={loading}
        >
          💀 {i18n.t("resolveTicketDialog.lost")}
        </Button>
        <Button
          fullWidth
          variant="outlined"
          onClick={() => onResolve("sin_cambio")}
          disabled={loading}
        >
          {i18n.t("resolveTicketDialog.noChange")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ResolveTicketDialog;
